// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pm-projects-page {
  padding: 1.5rem 1.75rem;
}

.pm-project-row-clickable,
.pm-project-row-clickable td {
  cursor: pointer !important;
}

.pm-project-row-clickable:hover td {
  background-color: #f0f6f7 !important;
}

.pm-projects-page .page-header {
  margin-bottom: 1.25rem;
}

.pm-projects-page .card {
  border-color: #e7edf3;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);
}

.pm-projects-page .card-header {
  align-items: flex-start;
  min-height: 64px;
}

.pm-projects-page .table {
  min-width: 1180px;
  table-layout: fixed;
  width: 1180px;
}

.pm-projects-page .table th {
  color: #667085;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.pm-projects-page .table td {
  vertical-align: middle;
}

.pm-project-col-no {
  width: 56px;
}

.pm-project-col-project {
  width: 300px;
}

.pm-project-col-owner,
.pm-project-col-pic {
  width: 185px;
}

.pm-project-col-stage {
  width: 105px;
}

.pm-project-col-progress {
  width: 150px;
}

.pm-project-col-deadline {
  width: 125px;
}

.pm-project-col-health {
  width: 90px;
}

.pm-project-col-updated {
  width: 155px;
}

.pm-projects-page .table-responsive {
  overflow-x: auto;
  scrollbar-gutter: stable;
}

.pm-projects-page .table td:nth-child(2) .fw-semibold,
.pm-projects-page .table td:nth-child(2) .pm-project-helper {
  display: block;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
}

.pm-projects-page .card-subtitle {
  font-size: 0.875rem;
  line-height: 1.35;
}

.pm-projects-page .form-label {
  color: #667085;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.pm-project-filter-badge {
  font-size: 0.65rem;
  min-width: 18px;
  padding: 2px 5px;
  right: -8px;
  top: -6px;
}

.pm-project-error-banner {
  border-left: 4px solid #f76707;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
}

/* Shown when arriving from a PM Dashboard KPI link (?stage=active|completed) */
.pm-project-dashboard-filter-banner {
  border-left: 4px solid #1f8f98;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
}

.pm-project-helper {
  font-size: 0.8125rem;
}

.pm-project-kpi-card {
  border-top: 3px solid var(--pm-project-kpi-color);
}

.pm-project-kpi-icon {
  align-items: center;
  background: var(--pm-project-kpi-bg);
  border-radius: 8px;
  color: var(--pm-project-kpi-color);
  display: inline-flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.pm-project-kpi-label {
  font-size: 0.73rem;
}

.pm-project-kpi-value {
  color: var(--pm-project-kpi-color);
  font-size: 1.4rem;
  line-height: 1;
}

.pm-project-kpi-primary {
  --pm-project-kpi-bg: rgba(31, 143, 152, 0.12);
  --pm-project-kpi-color: #1f8f98;
}

.pm-project-kpi-success {
  --pm-project-kpi-bg: rgba(0, 166, 121, 0.12);
  --pm-project-kpi-color: #00a679;
}

.pm-project-kpi-warning {
  --pm-project-kpi-bg: rgba(245, 159, 0, 0.14);
  --pm-project-kpi-color: #c87b00;
}

.pm-project-kpi-info {
  --pm-project-kpi-bg: rgba(22, 114, 185, 0.12);
  --pm-project-kpi-color: #1672b9;
}

.pm-project-kpi-purple {
  --pm-project-kpi-bg: rgba(111, 66, 193, 0.12);
  --pm-project-kpi-color: #6f42c1;
}

.pm-project-progress {
  flex: 1 1 auto;
  height: 5px;
  min-width: 96px;
}

.pm-project-pic-cell {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  min-width: 0;
}

.pm-project-pic-cell .fw-semibold {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pm-project-person-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pm-project-table-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 180px;
  text-align: center;
}

.pm-project-table-footer {
  gap: 1rem;
  justify-content: space-between;
}

.pm-project-pagination-controls {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.pm-project-page-size {
  align-items: center;
  color: #667085;
  display: flex;
  font-size: 0.8125rem;
  font-weight: 600;
  gap: 0.5rem;
  margin: 0;
  white-space: nowrap;
}

.pm-project-page-size .form-select {
  min-width: 74px;
}

.pm-project-pager {
  align-items: center;
  display: flex;
  gap: 0.375rem;
}

.pm-project-pager .btn {
  border-color: #d9e3eb;
  color: #667085;
}

.pm-project-page-current {
  align-items: center;
  background: #238cbe;
  border-radius: 6px;
  color: #fff;
  display: inline-flex;
  font-weight: 700;
  height: 32px;
  justify-content: center;
  min-width: 32px;
  padding: 0 0.5rem;
}

@keyframes pm-project-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.pm-project-spin {
  animation: pm-project-spin 1s linear infinite;
}

@media (max-width: 767.98px) {
  .pm-projects-page {
    padding: 1rem;
  }

  .pm-projects-page .btn-list {
    width: 100%;
  }

  .pm-projects-page .btn-list .btn {
    justify-content: center;
    width: 100%;
  }

  .pm-project-table-footer,
  .pm-project-pagination-controls {
    align-items: stretch;
    flex-direction: column;
  }

  .pm-project-pagination-controls {
    margin-left: 0 !important;
    width: 100%;
  }

  .pm-project-page-size,
  .pm-project-pager {
    justify-content: space-between;
    width: 100%;
  }

  .pm-project-page-size .form-select {
    width: auto;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .pm-projects-page {
    padding: 1rem;
  }

  .pm-projects-page .page-header .row {
    row-gap: 1rem;
  }

  .pm-projects-page .page-header .col-auto {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .pm-projects-page .page-header .btn-list {
    justify-content: flex-start;
  }

  .pm-project-kpi-icon {
    height: 40px;
    width: 40px;
  }

  .pm-project-kpi-value {
    font-size: 1.25rem;
  }

  .pm-projects-page .table {
    min-width: 1080px;
    width: 1080px;
  }

  .pm-project-col-project {
    width: 270px;
  }

  .pm-project-col-owner,
  .pm-project-col-pic {
    width: 160px;
  }

  .pm-project-col-updated {
    width: 135px;
  }

  .pm-project-table-footer {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PmProjects/PmProjects.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;;IAEE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pm-projects-page {\n  padding: 1.5rem 1.75rem;\n}\n\n.pm-project-row-clickable,\n.pm-project-row-clickable td {\n  cursor: pointer !important;\n}\n\n.pm-project-row-clickable:hover td {\n  background-color: #f0f6f7 !important;\n}\n\n.pm-projects-page .page-header {\n  margin-bottom: 1.25rem;\n}\n\n.pm-projects-page .card {\n  border-color: #e7edf3;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);\n}\n\n.pm-projects-page .card-header {\n  align-items: flex-start;\n  min-height: 64px;\n}\n\n.pm-projects-page .table {\n  min-width: 1180px;\n  table-layout: fixed;\n  width: 1180px;\n}\n\n.pm-projects-page .table th {\n  color: #667085;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.pm-projects-page .table td {\n  vertical-align: middle;\n}\n\n.pm-project-col-no {\n  width: 56px;\n}\n\n.pm-project-col-project {\n  width: 300px;\n}\n\n.pm-project-col-owner,\n.pm-project-col-pic {\n  width: 185px;\n}\n\n.pm-project-col-stage {\n  width: 105px;\n}\n\n.pm-project-col-progress {\n  width: 150px;\n}\n\n.pm-project-col-deadline {\n  width: 125px;\n}\n\n.pm-project-col-health {\n  width: 90px;\n}\n\n.pm-project-col-updated {\n  width: 155px;\n}\n\n.pm-projects-page .table-responsive {\n  overflow-x: auto;\n  scrollbar-gutter: stable;\n}\n\n.pm-projects-page .table td:nth-child(2) .fw-semibold,\n.pm-projects-page .table td:nth-child(2) .pm-project-helper {\n  display: block;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: anywhere;\n}\n\n.pm-projects-page .card-subtitle {\n  font-size: 0.875rem;\n  line-height: 1.35;\n}\n\n.pm-projects-page .form-label {\n  color: #667085;\n  font-weight: 600;\n  margin-bottom: 0.35rem;\n}\n\n.pm-project-filter-badge {\n  font-size: 0.65rem;\n  min-width: 18px;\n  padding: 2px 5px;\n  right: -8px;\n  top: -6px;\n}\n\n.pm-project-error-banner {\n  border-left: 4px solid #f76707;\n  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n}\n\n/* Shown when arriving from a PM Dashboard KPI link (?stage=active|completed) */\n.pm-project-dashboard-filter-banner {\n  border-left: 4px solid #1f8f98;\n  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n}\n\n.pm-project-helper {\n  font-size: 0.8125rem;\n}\n\n.pm-project-kpi-card {\n  border-top: 3px solid var(--pm-project-kpi-color);\n}\n\n.pm-project-kpi-icon {\n  align-items: center;\n  background: var(--pm-project-kpi-bg);\n  border-radius: 8px;\n  color: var(--pm-project-kpi-color);\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.pm-project-kpi-label {\n  font-size: 0.73rem;\n}\n\n.pm-project-kpi-value {\n  color: var(--pm-project-kpi-color);\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.pm-project-kpi-primary {\n  --pm-project-kpi-bg: rgba(31, 143, 152, 0.12);\n  --pm-project-kpi-color: #1f8f98;\n}\n\n.pm-project-kpi-success {\n  --pm-project-kpi-bg: rgba(0, 166, 121, 0.12);\n  --pm-project-kpi-color: #00a679;\n}\n\n.pm-project-kpi-warning {\n  --pm-project-kpi-bg: rgba(245, 159, 0, 0.14);\n  --pm-project-kpi-color: #c87b00;\n}\n\n.pm-project-kpi-info {\n  --pm-project-kpi-bg: rgba(22, 114, 185, 0.12);\n  --pm-project-kpi-color: #1672b9;\n}\n\n.pm-project-kpi-purple {\n  --pm-project-kpi-bg: rgba(111, 66, 193, 0.12);\n  --pm-project-kpi-color: #6f42c1;\n}\n\n.pm-project-progress {\n  flex: 1 1 auto;\n  height: 5px;\n  min-width: 96px;\n}\n\n.pm-project-pic-cell {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.pm-project-pic-cell .fw-semibold {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pm-project-person-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pm-project-table-state {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 180px;\n  text-align: center;\n}\n\n.pm-project-table-footer {\n  gap: 1rem;\n  justify-content: space-between;\n}\n\n.pm-project-pagination-controls {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n}\n\n.pm-project-page-size {\n  align-items: center;\n  color: #667085;\n  display: flex;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  gap: 0.5rem;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.pm-project-page-size .form-select {\n  min-width: 74px;\n}\n\n.pm-project-pager {\n  align-items: center;\n  display: flex;\n  gap: 0.375rem;\n}\n\n.pm-project-pager .btn {\n  border-color: #d9e3eb;\n  color: #667085;\n}\n\n.pm-project-page-current {\n  align-items: center;\n  background: #238cbe;\n  border-radius: 6px;\n  color: #fff;\n  display: inline-flex;\n  font-weight: 700;\n  height: 32px;\n  justify-content: center;\n  min-width: 32px;\n  padding: 0 0.5rem;\n}\n\n@keyframes pm-project-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pm-project-spin {\n  animation: pm-project-spin 1s linear infinite;\n}\n\n@media (max-width: 767.98px) {\n  .pm-projects-page {\n    padding: 1rem;\n  }\n\n  .pm-projects-page .btn-list {\n    width: 100%;\n  }\n\n  .pm-projects-page .btn-list .btn {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .pm-project-table-footer,\n  .pm-project-pagination-controls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .pm-project-pagination-controls {\n    margin-left: 0 !important;\n    width: 100%;\n  }\n\n  .pm-project-page-size,\n  .pm-project-pager {\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .pm-project-page-size .form-select {\n    width: auto;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1199.98px) {\n  .pm-projects-page {\n    padding: 1rem;\n  }\n\n  .pm-projects-page .page-header .row {\n    row-gap: 1rem;\n  }\n\n  .pm-projects-page .page-header .col-auto {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .pm-projects-page .page-header .btn-list {\n    justify-content: flex-start;\n  }\n\n  .pm-project-kpi-icon {\n    height: 40px;\n    width: 40px;\n  }\n\n  .pm-project-kpi-value {\n    font-size: 1.25rem;\n  }\n\n  .pm-projects-page .table {\n    min-width: 1080px;\n    width: 1080px;\n  }\n\n  .pm-project-col-project {\n    width: 270px;\n  }\n\n  .pm-project-col-owner,\n  .pm-project-col-pic {\n    width: 160px;\n  }\n\n  .pm-project-col-updated {\n    width: 135px;\n  }\n\n  .pm-project-table-footer {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
